// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"_18mt_"};